module.exports = __webpack_public_path__ + "static/media/default_project_icon.51d6b0e0.svg";